import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { CarrierType } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  onChange: (carrierType: M extends true ? CarrierType[] : CarrierType) => void
} & TomAutoCompleteProps<CarrierType, M>

export const CarrierTypeAutoComplete = observer(<M extends boolean = false>(props: Props<M>) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange } = props

  const [options] = useState<CarrierType[]>(
    Object.values(CarrierType).filter(c => c !== CarrierType.Universal && c !== CarrierType.Truck),
  )

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'carrier-type-autocomplete'}
      label={label ?? t('carrierType', 'Carrier type')}
      options={options}
      defaultValue={defaultValue}
      enablePortal
      placeholder={t('carrierType', 'Carrier type')}
      onChangeEntity={entity => {
        onChange(entity as M extends true ? CarrierType[] : CarrierType)
      }}
    />
  )
})
